import React from 'react';
import OneReport from '../OneReport/OneReport';
import MultipleReports from '../MultipleReports/MultipleReports';

const SelectAndDownloadReports = ({ reports, fetchReport }) => {
  if (!reports?.length) {
    return null;
  }

  return reports.length === 1 ? (
    <OneReport
      report={reports[0]}
      fetchReport={fetchReport}
    />
  ) : (
    <MultipleReports
      reports={reports}
      fetchReport={fetchReport}
    />
  );
};

export default SelectAndDownloadReports;
